import React from "react"

const Divider = () => {
    return (
        <><div className="fr-divider fr-border-light-shade fr-w-full " /><hr className=" fr-w-full fr-text-light-shade" /></>
      )
  }
  
  export default Divider